import { ERROR_FORM_ANSWERS_NEEDED, ERROR_FORM_ANSWERS_WRONG,
  missionPEField } from '../../../../../utils/constants'

const hasAnswer = (page_element, answer_selected) =>
  !!(!page_element.required || answer_selected)

const isCorrectAnswer = (page_element, answer_selected) =>
  !page_element.has_answer || page_element.page_element_options.map(peo =>
    answer_selected === peo.id && peo.is_correct_answer,
  ).reduce((x, y) => x || y, false)

export default (page_element, answer) => {
  const answer_selected = parseInt(answer[missionPEField(page_element)], 10)
  const has_answer = hasAnswer(page_element, answer_selected)
  const is_correct_answer = isCorrectAnswer(page_element, answer_selected)
  const errors = new Set()
  if (!has_answer) {
    errors.add(ERROR_FORM_ANSWERS_NEEDED)
  } else if (!is_correct_answer) {
    errors.add(ERROR_FORM_ANSWERS_WRONG)
  }
  return {
    valid: has_answer,
    is_correct_answer,
    errors,
  }
}



// WEBPACK FOOTER //
// ./src/reducers/Missions/Progress/validators/Form/radio.jsx